import React from 'react';
import ReactDOM from 'react-dom';

import AppProvider from './AppProvider';

ReactDOM.render(<AppProvider />, document.getElementById('root'));
